import React from 'react';
import { useField } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { COLLECTOR_FIELDS, PRIVATE_COLLECTOR_FIELDS } from '../../util/collectorProfile';

import FieldTextInput from '../FieldTextInput/FieldTextInput';

import css from './CollectorQuestionFields.module.css';

/** Hvor mange tegn der er tilbage - så grænsen ikke rammes som en overraskelse. */
const CharactersLeft = props => {
  const { name, maxLength } = props;
  const { input } = useField(name, { subscription: { value: true } });
  const used = typeof input.value === 'string' ? input.value.length : 0;
  const left = Math.max(maxLength - used, 0);

  return (
    <p className={classNames(css.charactersLeft, { [css.charactersLow]: left <= 20 })}>
      <FormattedMessage id="CollectorQuestions.charactersLeft" values={{ count: left }} />
    </p>
  );
};

/**
 * Nextmine: samler-spørgsmålene som formular-felter.
 *
 * Få, konkrete spørgsmål frem for et tomt "fortæl om dig selv"-felt. Et tomt
 * felt får folk til at skrive ingenting; "hvad drømmer du om at finde?" får
 * dem til at skrive noget, andre kan genkende sig selv i. Alle felter er
 * valgfri.
 *
 * De samme spørgsmål stilles to steder - i profil-indstillingerne og på
 * samlingssiden - så de bor her, ét sted.
 *
 * @param {Object} props
 * @param {boolean} props.includePrivate tag de skjulte spørgsmål med
 * @param {string?} props.fieldClassName klasse på hvert felt
 */
const CollectorQuestionFields = props => {
  const { className, fieldClassName, includePrivate = false } = props;
  const intl = useIntl();

  const renderField = ({ key, maxLength }) => (
    <div className={classNames(css.field, fieldClassName)} key={key}>
      <FieldTextInput
        type="textarea"
        id={key}
        name={key}
        maxLength={maxLength}
        label={intl.formatMessage({ id: `CollectorQuestions.${key}Label` })}
        placeholder={intl.formatMessage({ id: `CollectorQuestions.${key}Placeholder` })}
      />
      <CharactersLeft name={key} maxLength={maxLength} />
    </div>
  );

  return (
    <div className={className}>
      {COLLECTOR_FIELDS.map(renderField)}

      {includePrivate ? (
        <div className={css.privateSection}>
          {/* Vi spørger åbent om det private i stedet for at udlede det bag
              ryggen på folk - derfor står der tydeligt hvem der kan se svaret. */}
          <p className={css.privateNote}>
            <FormattedMessage id="CollectorQuestions.privateNote" />
          </p>
          {PRIVATE_COLLECTOR_FIELDS.map(renderField)}
        </div>
      ) : null}
    </div>
  );
};

export default CollectorQuestionFields;
